/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./widgetCard.vue?vue&type=template&id=78a17f2a&scoped=true"
import script from "./widgetCard.vue?vue&type=script&lang=js"
export * from "./widgetCard.vue?vue&type=script&lang=js"
import style0 from "./widgetCard.vue?vue&type=style&index=0&id=78a17f2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a17f2a",
  null
  
)

export default component.exports